import React from 'react';
import { Box, Icon, Text } from '@zillow/constellation-10';
import { IconBuildingFilled } from '@zillow/constellation-icons';

import stringHelper from '../../../utils/stringHelper';

import type { UserPropertyMultiplexCreateUnitResponseWebDto } from '@zg-rentals/rental-manager-env';

type Props = {
  isActive: boolean;
  unit: UserPropertyMultiplexCreateUnitResponseWebDto;
  onClick: () => void;
};

export const UnitOverviewCard = ({ unit, isActive, onClick }: Props) => {
  const bedroomDisplay = stringHelper.pluralize(unit.bedroomCount ?? '\u2014', 'Bedroom', 'Bedrooms');
  const bathroomDisplay = stringHelper.pluralize(unit.bathroomCount ?? '\u2014', 'Bathroom', 'Bathrooms');

  return (
    <Box
      data-testid="UnitOverviewCard"
      onClick={onClick}
      css={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '400',
        height: '68px',
        border: '1px solid',
        borderColor: 'border.muted',
        borderRadius: '100',
        backgroundColor: isActive ? 'bg.softer' : 'bg.neutral',
        cursor: 'pointer',
      }}
    >
      <Box css={{ marginRight: '400' }}>
        <Icon role="img" size="md">
          <IconBuildingFilled />
        </Icon>
      </Box>

      <Text textStyle="body-sm-bold">Unit {unit.unitNumber}</Text>

      <Box
        css={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          marginLeft: 'auto',
          gap: '50',
        }}
      >
        <Text textStyle="body-sm-bold">{bedroomDisplay}</Text>
        <Text> • </Text>
        <Text textStyle="body-sm-bold">{bathroomDisplay}</Text>
      </Box>
    </Box>
  );
};

export default UnitOverviewCard;
